import { render, staticRenderFns } from "./ApproveDialog.vue?vue&type=template&id=70e60073&scoped=true"
import script from "./ApproveDialog.vue?vue&type=script&lang=js"
export * from "./ApproveDialog.vue?vue&type=script&lang=js"
import style0 from "./ApproveDialog.vue?vue&type=style&index=0&id=70e60073&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e60073",
  null
  
)

export default component.exports